import React, { useState, useEffect, useCallback } from 'react'
import { Route, Redirect } from "react-router-dom";


// constant
import * as keys from '../../../assets/constants/localStore';
//path
import * as pathNames from '../../../assets/constants/pathName'

const PrivateRoute = ({ children, ...rest }) => {

    const [islogin, setIslogin] = useState(null)

    useEffect(() => {
        const login = localStorage.getItem(keys.FACE_PAY_BO_V2_LOGIN)

        if(!login) {
            setIslogin(false)
            return;
        }

        setIslogin(true)
    }, [])

    const _renderRoute = useCallback(({ location }) => {
        if (islogin === null) return null;
        return islogin ? (
            children
        ) : (
                <Redirect
                    to={{
                        pathname: `/${pathNames.LOGIN}`,
                        state: { from: location }
                    }}
                />
            )
    }, [islogin])

    return (
        <Route
            {...rest}
            render={_renderRoute}
        />
    );
}

export default PrivateRoute
